import { put, call, takeEvery } from "redux-saga/effects";
import { getreportPurchaseApi } from "../services/reportPurchaseServices";
import { reportPurchaseConstants } from "../constants";

export function* reportPurchaseSaga(payload) {
    try {
        const response = yield call(getreportPurchaseApi, payload.pageNo, payload.filterData);
        yield put({ type: reportPurchaseConstants.GET_REPORT_PURCHASE_SUCCESS, response });
    } catch (error) {
        yield put({ type: reportPurchaseConstants.GET_REPORT_PURCHASE_FAILURE, error });
    }
}

export default function* reportPurchase() {
    yield takeEvery(reportPurchaseConstants.GET_REPORT_PURCHASE, reportPurchaseSaga);
}